<template>
  <CCard>
    <!-- <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader> -->
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 20 : 5"
        :dark="dark"
        pagination
      >
        <template #ativo="{item}">
          <td>
            <CBadge :color="getBadge(item.ativo)">{{!item.ativo ? 'Ativo' : 'Arquivado'}}</CBadge>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['nome', 'escolaridade', 'telefone', 'ativo' ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    getBadge (ativo) {
     /*  return ativo === false ? 'success' 
        : ativo === null ? 'success'
        : ativo === true ? 'danger'
          : ativo === 'Inactive' ? 'secondary'
            : ativo === 'Pending' ? 'warning'
              : ativo === 'Banned' ? 'danger' : 'primary' */

              if(ativo) {
                return 'danger'
              } else {
                return 'success'
              }
    }
  }
}
</script>
